import { apiBaseUrl } from "./constants/env.constants";

const { REACT_APP_BACKEND_URL } = process.env;

let gateway = apiBaseUrl;

if (
  !(REACT_APP_BACKEND_URL === null || REACT_APP_BACKEND_URL === undefined) &&
  REACT_APP_BACKEND_URL.trim().length !== 0
) {
  gateway = REACT_APP_BACKEND_URL;
}

export const apiGateway = gateway;
